import NachWrapper from '../components/NachWrapper';
import MandateDashboardForm from './components/MandateDashboardForm';
// import MandateDashboardForm from './components/MandateDashboardForm';

function Mandate_approve() {
  return (
    <NachWrapper
      title="Mandate Approve Dashboard"
      className=" col-xs-12 col-sm-12 col-md-12"
      style={{ marginLeft: '15px' }}
    >
      <MandateDashboardForm />
    </NachWrapper>
  );
}

export default Mandate_approve;
